import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import Typography from '@repo/ui/typography'
import { useQuery } from '@tanstack/react-query'

import { ContactVersionEnum, getContactVersion } from '../../../api/enrollments/get-has-transport'
import LoadingScreen from '../../../components/elements/loading/loading-screen'
import ClientCenterContactWithTransport from '../../../components/pages/client-space/trip-information/client-center-contact-with-transport'
import ClientCenterContactWithoutTransport from '../../../components/pages/client-space/trip-information/client-center-contact-without-transport'
import ClientHostFamilyContactWithTransport from '../../../components/pages/client-space/trip-information/client-host-family-contact-with-transport'
import ClientHostFamilyContactWithoutTransport from '../../../components/pages/client-space/trip-information/client-host-family-contact-without-transport'
import useEnrollment from '../../../lib/hooks/use-enrollment'

const ClientTripInformationContact = () => {
  const { enrollment } = useEnrollment()

  const { data, isLoading } = useQuery({
    queryKey: ['enrollment-contact-version', enrollment.id],
    queryFn: async () => getContactVersion(enrollment.id),
    enabled: !!enrollment.enrollmentCenter && !!enrollment.mainProposition
  })

  if (!enrollment.enrollmentCenter || !enrollment.mainProposition)
    return (
      <Typography variant="label-medium" color={tailwindColors.grey.lighter}>
        Aucune information de contact disponible.
      </Typography>
    )

  if (isLoading || !data) return <LoadingScreen />

  // Component mapping approach
  const contactComponents = {
    [ContactVersionEnum.CENTER_WITH_TRANSPORT]: ClientCenterContactWithTransport,
    [ContactVersionEnum.CENTER_WITHOUT_TRANSPORT]: ClientCenterContactWithoutTransport,
    [ContactVersionEnum.HOST_FAMILY_WITH_TRANSPORT]: ClientHostFamilyContactWithTransport,
    [ContactVersionEnum.HOST_FAMILY_WITHOUT_TRANSPORT]: ClientHostFamilyContactWithoutTransport
  }

  const ContactComponent = contactComponents[ContactVersionEnum.HOST_FAMILY_WITHOUT_TRANSPORT]

  if (!ContactComponent) {
    console.error('Unknown contact version:', data.contactVersion)
    return <div>Erreur: Version de contact non supportée</div>
  }

  return <ContactComponent />
}

export default ClientTripInformationContact
